var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('DataForm', {
    attrs: {
      "schema": _vm.formSchema,
      "inline": true
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, [_c('template', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_vm._v(" " + _vm._s(_vm.queryText) + " ")]), _vm.resetText ? _c('el-button', {
    attrs: {
      "type": "default",
      "size": "small"
    },
    on: {
      "click": _vm.doReset
    }
  }, [_vm._v(" " + _vm._s(_vm.resetText) + " ")]) : _vm._e(), _vm.hasMore ? _c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.toggleMore
    }
  }, [_vm._v(" " + _vm._s(_vm.isCollapse ? _vm.expandText : _vm.collapseText) + " "), _c('i', {
    class: _vm.isCollapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
  })]) : _vm._e()], 1)], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };